import {match} from 'ts-pattern';

import {SaleVehicleTargetAlbum} from '../hooks/useAttachPhotosToSaleVehicleAlbum';

export const getTargetAlbum = (targetAlbum: unknown): SaleVehicleTargetAlbum =>
  match(Array.isArray(targetAlbum) ? targetAlbum.at(0) : null)
    .with('PHOTOS_CAR_SALES', 'PHOTOS_CAR_PURCHASE', (value) => value)
    .otherwise(() => 'PHOTOS_CAR_PURCHASE');
